import type { RouteLocationNormalized } from "vue-router";

export const routerGuard = async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
  // here you can add any route guard logic you want
  // for example, you can redirect to a login page if the user is not logged in
  console.log(from.path, "to", to.path);
};
